import type { Workbook } from 'exceljs';
import type { ExportTable } from './export.types';

export const XLSX_MIME_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
const MAX_COLUMN_WIDTH = 80;

/** Adds a sheet with the bold headers and the rows of the table to the workbook. */
export const buildListWorkbook = (workbook: Workbook, { headers, rows }: ExportTable, sheetName: string): Workbook => {
  const sheet = workbook.addWorksheet(sheetName);
  headers.forEach((header, index) => {
    // reduce instead of Math.max(...): spreading very large lists exceeds the max number of call arguments
    const longest = rows.reduce((max, row) => Math.max(max, String(row[index] ?? '').length), header.length);
    sheet.getColumn(index + 1).width = Math.min(longest, MAX_COLUMN_WIDTH);
  });
  sheet.addRow(headers).font = { bold: true };
  for (const row of rows) {
    sheet.addRow(row);
  }
  return workbook;
};
